<section id="history" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>Our Projects</h1>
                <ul>
                  <li>
                    <a routerlink="/" href="/">Home</a>
                  </li>
                  <li>Our Projects</li>
                </ul>
            </div>
        </div> 
        <div class="container bottom-div wow fadeInUp" data-wow-delay="0.5s">
        </div>
    </div>
</section>

<!-- 
<section>
    <div class="container">
        <div class="row">
            <div class="col md-4">
                <img src="/assets/images/img/medical/medical-img-1.jpg" class="img-fluid" alt="">
            </div>
            <div class="col md-4">
                <img src="/assets/images/img/medical/medical-img-2.jpg" class="img-fluid" alt="">
            </div>
            <div class="col md-4">
                <img src="/assets/images/img/medical/medical-img-3.jpg" class="img-fluid" alt="">
            </div>
            <div class="col md-4">
                <img src="/assets/images/img/medical/medical-img-4.jpg" class="img-fluid" alt="">
            </div>
        </div>
    </div>
</section> -->

<div class="pt-5 pb-5 pos-list">
    <div class="container">
        <h2 class="text-center mb-5">List of Position</h2>
        <div class="row">
            <div class="col-md-3">
                <ol start="1">
                    <li><strong>Nurse</strong>
                        <ul>
                            <li>Medical Technologist</li>
                            <li>Rad Technologist</li>
                            <li>Physical Theraphist</li>
                            <li>Occupational Theraphist</li>
                            <li>Speech Theraphist</li>
                            <li>Pharmacist</li>
                        </ul>
                    </li>
                </ol>
            </div>
            <div class="col-md-3">
                <ol start="2">
                    <li><strong>Engineering</strong>
                        <ul>
                            <li>Biomedical Engineer</li>
                            <li>Biomedical Technician</li>
                            <li>Maintenance Technician</li>
                        </ul>
                    </li>
                </ol>
            </div>
            <div class="col-md-3">
                <ol start="3">
                    <li><strong>Dentist</strong> 
                        <ul>
                            <li>Orthodentist</li>
                            <li>Dental Technician</li>
                        </ul>
                    </li>
                </ol>
            </div>
            <div class="col-md-3">
                <ol start="3">
                    <li><strong>Labor and Maintenance</strong> 
                        <ul>
                            <li>Housekeeping</li>
                            <li>Food Server</li>
                            <li>Waiter</li>
                            <li>Waitress</li>
                        </ul>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</div>


<div class="container pt-5">
    <div class="text-center wow fadeInUp pt-5">
        <h2 class="content-title">OUR PARTNERS</h2>
    </div>
    <div class="row pt-5">
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/Armed-Forces-Hospital-King-Abdulaziz-Airbase.png" class="img-fluid" alt="">
            <p>Armed Forces Hospital King Abdulaziz Airbase</p>
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/Armed-Forces-Hospital-Southern-Region-Khamiz-Mushayt.png" class="img-fluid" alt="">
            <p>Armed Forces Hospital Southern Region Khamiz Mushayt</p>
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/King-Khalid-Military-City-Hospital.png" class="img-fluid" alt="">
            <p>King Khalid Military City Hospital</p>
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/King-salman-armed-forces.png" class="img-fluid" alt="">
            <p>King salman armed forces</p>
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/MEDLINE-RECRUITMENT.png" class="img-fluid" alt="">
            <p>MEDLINE RECRUITMENT</p>
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/Najran-Armed-Forces-Hospital.png" class="img-fluid" alt="">
            <p>Najran Armed Forces Hospital</p>
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/Prince-Sultan-Military-Medical.png" class="img-fluid" alt="">
            <p>Prince Sultan Military Medical</p>
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/Sharurah-Armed-Forces-Hospital.png" class="img-fluid" alt="">
            <p>Sharurah Armed Forces Hospital</p>
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/Security-Forces-Hospital.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/King-Fahd-Armed-Forces-Hospital.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/Ministry-of-national-guard-health-affairs.png" class="img-fluid" alt="">
        </div>
        <div class="col-md-4 text-center">
            <img src="/assets/images/logo/industries/medical/negelle-arsi-general-hospital.png" class="img-fluid" alt="">
        </div>
    </div>
</div>